export class SocialHistoryModel {
  socialHistoryId: any
  tobacoStatusIdPk: any
  tobacoStatusId: any
  riskAssessmentId: any

  practiceCode: any
  patientAccount: any
  educationId: any
  tobacoStatus: any
  tobacoStartDate: any
  tobacoEndDate: any
  alcohalPerDay: any
  alcohalUsage: any
  drugUse: any
  industryCode: any
  industryStartDate: any
  industryEndDate: any
  exercise: any
  seatBelts: any
  exposure: any
  feels_Safe: any
  howLongUsingTobaco: any
  caffineUsage: any
  drugUseDetails: any
  ipAddress: any
  request: Request[] = []
  pmh: PMH[] = []
}
export class Request {
  patientIntakeFormsId: any
  patientIntakeFormsName: any
  intakeFormQuestionId: any
  sectionName: any
  columnType: any
  options: any
}
export class PMH {
  afTblPatientMedicalHistoryItemsSettingId: any
  afTblPatientMedicalHistoryItemsSettingCustomizedId: any
  diagnosisDescription: any
  deleted: any
  diagnoseId: any
  isActive: any
}